import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchUser,
  selectUserObject,
  selectUserCallStatus
} from '../../features/user/userSlice'
import EditLanguageMobile from './EditLanguageMobile'
import EditLanguageDesktop from './EditLanguageDesktop'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import isMobileView from '../../util/MobileView'
import { LanguageSelectionManager } from '../../features/language-selector/LanguageSelectionManager'

export function EditLanguage() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isMobile = isMobileView()
  const userCallStatus = useSelector(selectUserCallStatus)
  const userObj = useSelector(selectUserObject)

  useEffect(() => {
    if (userCallStatus === 'idle') {
      dispatch(fetchUser())
    }
  }, [userCallStatus, dispatch])

  const {
    languageSelectorComponent,
  } = LanguageSelectionManager({
    dispatch,
    userObj: userObj || {},
    t,
  })

  const isPageLoading = !((userCallStatus === 'succeeded' || userCallStatus === 'failed'))

  return (
    <MarginWrapper>
      {isMobile ? (
        <EditLanguageMobile
          t={t}
          languageSelectorComponent={languageSelectorComponent}
          isPageLoading={isPageLoading}
        />
      )
        : (
          <EditLanguageDesktop
            t={t}
            languageSelectorComponent={languageSelectorComponent}
            isPageLoading={isPageLoading}
          />
        )}
    </MarginWrapper>
  )
}
